import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 14.01V22H16.98V15.01C16.98 14.46 16.53 14.01 15.97 14.01H8.03C7.47 14.01 7.02 14.46 7.02 15.01V22H5V14.01C5 12.9 5.9 12.01 7.02 12.01H16.98C18.1 12.01 19 12.91 19 14.01ZM7.49 6.47C7.49 4.01 9.51 2 12 2C14.49 2 16.51 4.01 16.51 6.47C16.51 8.93 14.49 10.94 12 10.94C9.51 10.94 7.49 8.94 7.49 6.47ZM9.51 6.47C9.51 7.83 10.63 8.94 12 8.94C13.37 8.94 14.49 7.83 14.49 6.47C14.49 5.11 13.37 4 12 4C10.63 4 9.51 5.11 9.51 6.47Z" fill={ fill || 'currentColor' } />
    </svg>
);
